import {
    setRegisStatus,
    registrationEnum,
    emitTrack,
    regType
} from './register-track';
import util from '@/common/util';
function factory(type) {
    return {
        created() {
            this.onTrackInput = util
                .debounce(this.onTrackInput, 2000)
                .bind(this);
            this.onTrackEmail = util
                .debounce(this.onTrackEmail, 2000)
                .bind(this);
            this.onTrackPhone = util
                .debounce(this.onTrackPhone, 2000)
                .bind(this);
            this.onTrackName = util.debounce(this.onTrackName, 2000).bind(this);
            setRegisStatus({ styleType: registrationEnum.styleType[type] });
        },
        mounted() {
            emitTrack(regType.appear);
        },
        data: function() {
            return {
                regType
            };
        },
        methods: {
            onTrackInput(type, state) {
                emitTrack(regType[type], state);
            },
            onTrackEmail(type, state) {
                emitTrack(regType[type], state);
            },
            onTrackPhone(type, state) {
                emitTrack(regType[type], state);
            },
            onTrackName(type, state) {
                emitTrack(regType[type], state);
            },
            onTrack(type, state, error) {
                emitTrack(regType[type], state, error);
            }
        }
    };
}

export const chatForm = factory('chatForm');

export const singleColumn = factory('singleColumn');

export const twoColumn = factory('twoColumn');

export const oneStepColumn = factory('oneStepColumn');

export const ppForm = factory('ppForm');

export const sellForm = factory('sellForm');
